import React from 'react';

export interface AuthAlertProps {
  message: React.ReactNode;
  tone?: 'error' | 'info' | 'success';
  className?: string;
}

const toneStyles: Record<NonNullable<AuthAlertProps['tone']>, string> = {
  error: 'bg-rose-100 border-2 border-rose-400 text-rose-800',
  info: 'bg-slate-100 border-2 border-slate-300 text-slate-800',
  success: 'bg-emerald-100 border-2 border-emerald-400 text-emerald-800',
};

export const AuthAlert: React.FC<AuthAlertProps> = ({ message, tone = 'error', className }) => {
  return (
    <div
      role="alert"
      aria-live="polite"
      className={[
        'p-4 rounded-lg text-sm font-medium',
        toneStyles[tone],
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {message}
    </div>
  );
};
